import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'ztsi-pager',
	templateUrl: './ztsi-pager.component.html',
	styleUrls: ['./ztsi-pager.component.css']
})
export class ZtsiPagerComponent implements OnInit {

	pages: number[];
	@Input() pageSize: number = 2;
	@Input() totalPageNumber: number = 1;
	@Input() pageNumber: number = 1;
	@Output() onFetchData: EventEmitter<number> = new EventEmitter();

	constructor() { }

	ngOnInit() {
		this.assignPages();
	}

	goToPage(page: number) {
		if (page > this.totalPageNumber || page < 1) {
			return;
		}

		this.pageNumber = page;
		this.onFetchData.emit(page);
	}

	assignPages() {
		let startPage = this.pageNumber > 3 ? this.pageNumber - 2 : 1;
		let endPage = this.pageNumber >= this.totalPageNumber ? this.pageNumber + 2 : this.totalPageNumber;

		this.pages = [];
		for (startPage; startPage <= endPage; startPage++) {
			this.pages.push(startPage);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-pager/ztsi-pager.component.ts